var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/giveaway-component-coming-soon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"featureConfigs.session-m-configuration"]));
frame.set("sessionmConfig", t_1, true);
if(frame.topLevel) {
context.setVariable("sessionmConfig", t_1);
}
if(frame.topLevel) {
context.addExport("sessionmConfig", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "sessionmConfig"),"comingSoonImage.fields.file.url",""]));
frame.set("giveawayComingSoonSrc", t_2, true);
if(frame.topLevel) {
context.setVariable("giveawayComingSoonSrc", t_2);
}
if(frame.topLevel) {
context.addExport("giveawayComingSoonSrc", t_2);
}
output += "\n\n<img\n    class=\"c-giveaway__coming-soon\"\n    src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "giveawayComingSoonSrc"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 5, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["giveaway-coming-soon-alt"])), env.opts.autoescape);
output += "\"\n/>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/giveaway-component-coming-soon.j2"] , dependencies)